import MyTabs from "../../../components/MyTabs";
import CreditsCasts from "./CreditsCasts";
import Editorial from "./Editorial";
import LyricsTracks from "./LyricsTracks";
import Synopsis from "./Synopsis";
import WatchFilm from "./WatchFilm";

const BodyOfWork = (props) => {
  
    const tabs = [
        { id: "editorial", title: "Editorial", Component: Editorial },
        { id: "synopsis", title: "Synopsis" , Component: Synopsis},
        { id: "creditsCasts", title: "Credits & Casts" , Component: CreditsCasts},
        { id: "watch-film", title: "Watch Full Film" , Component: WatchFilm},
        { id: "lyrics-tracks", title: "Lyrics & Sound Tracks" , Component: LyricsTracks},
      ];

return (
    <>
        <MyTabs list={tabs}/>
    </>
)
};

export default BodyOfWork;